<template>
<div>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        height="48" 
        src="img/avatars/wetrusty-logo.png"
        viewBox="0 0 110 134"
      />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          主控板
        </CHeaderNavLink>
      </CHeaderNavItem>     
    </CHeaderNav>
    <CHeaderNav class="mr-4">  
      <span :style="{ display:'inline-block', width:'20px', height:'20px',
                      'border-radius':'50%', 'background-color':this.api_light, marginLeft:'8px'}" >
      </span>
      {{ this.api_msg }}
    </CHeaderNav>
    <CHeaderNav class="mr-4">  
      {{ name }} 您好!
      <TheHeaderDropdownList/>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
  <div class="control-section">
    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='更換密碼' width='30%' :buttons='dialog_buttons'  >
      <div class="form-row">
        <div class="col-md-12" style="margin-bottom: 20px;">請輸入密碼 
          <ejs-textbox id='textbox' class="no-autofill-pwd" placeholder="密碼" type="password" v-model="e_pwd"  autocomplete="off"></ejs-textbox>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12" >請確認密碼
          <ejs-textbox id='textbox' class="no-autofill-pwd" placeholder="密碼" type="password" v-model="e_pwd2"  autocomplete="off"></ejs-textbox>
        </div>
      </div>
      <div class="form-row">
        <div v-if="e_msg != ''">
           <span style="color:red">{{ e_msg }}</span>
        </div>
      </div>
    </ejs-dialog>        
  </div>
</div>

</template>

<script>

import Vue from "vue";
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownList from './TheHeaderDropdownList'
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';  
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";

Vue.use(TooltipPlugin);
Vue.use(DialogPlugin);
Vue.use(TextBoxPlugin);
Vue.use(DropDownListPlugin);

import alertImg from '../../public/img/avatars/alert.png';

export default {  
  inject:['reload'], // 注入依賴
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownList
  },
  
  data () {
    return { 
      localFields: { text: 'name', value: 'id' },
      name : localStorage.getItem('name'),
      select_value_office : "",
      office_data: [],
      alert_img : alertImg,
      user_data: "", e_pwd: "", e_pwd2: "", e_msg: "",
      dialog_buttons: [{
          click: this.dialog_editOkClick,
          buttonModel: { content: '確認更改密碼', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
      }],
      api_msg:'服務無啟動',api_light:'#ED1C24'
    }
  },
  methods: {      
    getApi() {
      this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `Dashboard/Service`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) {
          this.api_msg = '服務無啟動';
          this.api_light = '#ED1C24';
          return;
        }
        this.api_msg = response.data.msg;
        this.api_light = '#22B14C';
      })
      .catch((error) => { 
        console.error(error)
      }) 
    }
  },
  created() {      

  },
  mounted() {
    this.getApi()
    // 每 5 秒呼叫一次
    this.timer = setInterval(() => {
      this.getApi()
    }, 5000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style scoped>
  .no-autofill-pwd {
    -webkit-text-security: disc !important;
  }
</style>